import BookListPage from "../components/pages/book-management/BookListPage";
import BookFormPage from "../components/pages/book-management/BookFormPage";
import BookDeliveryPage from "../components/pages/book-management/BookDeliveryPage";
import BookPickingUpPage from "../components/pages/book-management/BookPickingUpPage.vue";
import BookDeliveryPurchaseReport from "../components/pages/book-management/BookDeliveryPurchaseReport.vue";

export default [
  {
    path: "books",
    name: "book.management.index",
    component: BookListPage,
    meta: {
      access: { menu: "book-management", subMenu: "book-management" },
      authRequired: true,
      module: "book-management",
    },
  },
  {
    path: "books/create",
    name: "book.management.create",
    component: BookFormPage,
    meta: {
      access: { menu: "book-management", subMenu: "book-management" },
      authRequired: true,
      module: "book-management",
    },
  },
  {
    path: "books/:bookId/edit",
    name: "book.management.edit",
    component: BookFormPage,
    meta: {
      access: { menu: "book-management", subMenu: "book-management" },
      authRequired: true,
      module: "book-management",
    },
  },
  {
    path: "book-delivery",
    name: "book.delivery",
    component: BookDeliveryPage,
    meta: {
      access: { menu: "book-management", subMenu: "book-delivery" },
      authRequired: true,
      module: "book-management",
    },
  },
  {
    path: "books/pickup",
    name: "book.pickup",
    component: BookPickingUpPage,
    meta: {
      access: { menu: "book-management", subMenu: "book-pickup" },
      authRequired: true,
      module: "book-management",
    },
  },
  {
    path: "books/book-delivery-purchase-report",
    name: "book.book-delivery-purchase-report",
    component: BookDeliveryPurchaseReport,
    meta: {
      access: { menu: "book-management", subMenu: "book-delivery-purchase-report" },
      authRequired: true,
      module: "book-management",
    }
  },
];
